import { errorHandler } from '@/lib/ErrorHandler';
import { getClient } from '@/lib/restClient';
import {
  SearchItem,
  SearchItemParams,
} from '@/pages/menu-managements/services/searchItem';
import { MenuManagementBrandOptionGroupService } from '@/services/BrandOptionGroup/MenuManagementOptionGroupService';

export const useMenuManagementSearchBrandOptionGroups = async (
  params: SearchItemParams
): Promise<SearchItem[]> => {
  const menuManagementBrandOptionGroupService =
    new MenuManagementBrandOptionGroupService(getClient());
  try {
    return await menuManagementBrandOptionGroupService.search(params);
  } catch (error) {
    // @ts-ignore TS2322
    return errorHandler({ error });
  }
};
